export const APIURL = 'https://api-staging.shedpaper.com';
//export const APIURL = 'http://localhost:8180';